<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSubmit">
    <v-text-field
      v-model="form.name"
      :rules="rules.name"
      label="Название"
    />

    <b>Данные</b>

    <div
      v-for="(item, index) in form.mappings"
      :key="index"
      class="d-flex"
    >
      <v-text-field
        v-model="form.mappings[index].key"
        :rules="rules.keyField"
        class="pr-2"
        label="Ключ"
      />
      <v-text-field
        v-model="form.mappings[index].value"
        :rules="rules.valueField"
        class="pl-2"
        label="Значение"
      />
      <v-btn
        icon
        class="red align-self-center ml-2"
        x-small
        dark
        @click="remove(index)"
      >
        <v-icon>remove</v-icon>
      </v-btn>
    </div>
    <div class="d-flex justify-end">
      <v-btn
        small
        color="primary"
        dark
        class="mr-2"
        @click="add"
      >
        <v-icon small>add</v-icon> Добавить ключ
      </v-btn>
      <v-btn small color="green" dark @click="onSubmit">
        Сохранить
      </v-btn>
    </div>
  </v-form>
</template>

<script>

const createDefaultForm = () => ({
  name: '',
  mappings: [{ key: '', value: '' }],
});

const createDefaultRules = () => ({
  name: [
    v => !!v || 'Поле обязательно для заполнения',
  ],
  keyField: [
    v => !!v || 'Поле обязательно для заполнения',
  ],
  valueField: [
    v => !!v || 'Поле обязательно для заполнения',
  ],
});

export default {
  name: 'import-kafka-dictionary-form',
  props: {
    data: {
      type: Object,
      default: createDefaultForm,
    },
  },
  data: () => ({
    valid: true,
    form: createDefaultForm(),
    rules: createDefaultRules(),
    isEdit: false,
  }),
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(value) {
        this.initData(value);
      },
    },
  },
  created() {
    this.initData(this.data);
  },
  methods: {
    initData(data) {
      this.isEdit = data.id !== undefined;
      this.form = {
        ...this.form,
        ...JSON.parse(JSON.stringify(data)),
      };
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$emit('submit', {
          form: this.form,
          isEdit: this.isEdit,
        });
        this.form = createDefaultForm();
        this.isEdit = false;
      }
    },

    add() {
      this.form.mappings.push({ key: '', value: '' });
    },

    remove(i) {
      this.form.mappings = this.form.mappings.filter((_, k) => i !== k);
    },
  },
};
</script>

<style scoped>

</style>
